import React, { type PropsWithChildren } from "react";
import cx from "classnames";

import * as styles from "@/features/betslip/components/parts/BetSpine.module.scss";

type BetSpineProps = PropsWithChildren<{
  className?: string;
  /** Inset the wrapped rows with vertical padding while the line still spans the
   *  full height — used inside a ComboGroup so the legs breathe but the spine
   *  still reaches the group's top and bottom edges. */
  padded?: boolean;
}>;

// Draws the single vertical connector line that runs down the icon column,
// behind the content it wraps. One line for the whole region — rows and inline
// alerts alike — instead of a per-row segment. The rows' silks/outcome icons
// sit on top and occlude the line, so it reads as running through them.
export const BetSpine = ({ className, padded, children }: BetSpineProps) => (
  <div className={cx(styles.spine, { [styles.padded]: padded }, className)}>
    {children}
  </div>
);
